import type { ReactNode } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { Navigation } from './Navigation';
import { portalColors, portalSpacing } from '../../styles/theme';

interface AppShellProps {
  children: ReactNode;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: portalColors.appShellBg,
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    paddingTop: portalSpacing.page,
    paddingBottom: portalSpacing.page,
    paddingLeft: portalSpacing.xl,
    paddingRight: portalSpacing.xl,
  },
  content: {
    width: '100%',
  },
});

export function AppShell({ children }: AppShellProps): JSX.Element {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Navigation />
      <main className={styles.main}>
        <div className={styles.content}>{children}</div>
      </main>
    </div>
  );
}
